/**
 * PlatformBridgeFactory — Detects current runtime container and returns IPlatformBridge
 */

import type { IPlatformBridge } from './types';
import type { PlatformType } from '@tg-miniapp/shared-types';
import { TelegramBridge } from './TelegramBridge';
import { MaxBridge } from './MaxBridge';
import { StandaloneWebBridge } from './StandaloneWebBridge';

let cachedBridge: IPlatformBridge | null = null;

export function detectPlatform(): PlatformType {
  if (typeof window === 'undefined') return 'web';

  const hash = window.location.hash;
  const search = window.location.search;

  // 1. MAX Messenger detection (WebAppData in hash/search, userAgent MAX, or native WebViewHandler)
  const hasMaxParams = hash.includes('WebAppData=') || search.includes('WebAppData=') || hash.includes('WebAppPlatform=');
  const hasMaxBridge = typeof (window as any).WebViewHandler !== 'undefined' || (typeof navigator !== 'undefined' && navigator.userAgent.includes('MAX'));
  const maxInitData = (window as any).WebApp?.initData;

  if (hasMaxParams || hasMaxBridge || (maxInitData && !window.Telegram?.WebApp?.initData)) {
    return 'max';
  }

  // 2. Telegram WebApp detection (tgWebAppData in hash/search, Telegram.WebApp.initData or valid platform)
  const tgInitData = window.Telegram?.WebApp?.initData;
  const hasTgParams = hash.includes('tgWebAppData=') || search.includes('tgWebAppData=') || hash.includes('tgWebAppPlatform=');
  const hasTgPlatform = typeof window.Telegram?.WebApp !== 'undefined' && window.Telegram.WebApp.platform && window.Telegram.WebApp.platform !== 'unknown';
  
  if (tgInitData || hasTgParams || hasTgPlatform) {
    return 'telegram';
  }

  return 'web';
}

export function getPlatformBridge(): IPlatformBridge {
  if (cachedBridge) return cachedBridge;

  const platform = detectPlatform();

  if (platform === 'max') {
    cachedBridge = new MaxBridge();
  } else if (platform === 'telegram') {
    cachedBridge = new TelegramBridge();
  } else {
    cachedBridge = new StandaloneWebBridge();
  }

  return cachedBridge;
}
